const url = '/api/v1/gradebook/';

export const state = {
    lessonData: [],
    modalEditLesson: false,

    modalReschedulingLesson: false,
    modalTeacherReplacement: false,
    modalStudentAbsences: false,
    modalLessonLink: false,
    modalLessonType: false,

    teachers: [],
}

export const getters = {
    lessonData: state => state.lessonData,
    modalEditLesson: state => state.modalEditLesson,

    modalReschedulingLesson: state => state.modalReschedulingLesson,
    modalTeacherReplacement: state => state.modalTeacherReplacement,
    modalStudentAbsences: state => state.modalStudentAbsences,
    modalLessonLink: state => state.modalLessonLink,
    modalLessonType: state => state.modalLessonType,

    teachers: state => state.teachers,
}

export const mutations = {

    setData(state, {type, items}) {
        state[type] = items;
    },

    clearData(state, {types}) {
        for (let key in state) {
            for (let type in types) {
                key === types[type] ? state[key] = null : false
            }
        }
    }
}

export const actions = {

    async showModalEditLesson({commit, state, dispatch}, params) {
        dispatch('loading/addLoading', '', {root: true})
        const {data: {lessonData}} = await axios.get(url + 'get-full-lesson-data', {
            params: {
                'lesson_id': params.lesson.id,
                'group_id': params.group.id,
                'program_id': params.program.id,
                'module_id': params.module.id ?? null,
            }
        });
        dispatch('loading/subLoading', '', {root: true})

        commit('setData', {type: 'lessonData', items: lessonData});
        commit('setData', {type: 'modalEditLesson', items: true});
    },

    async showModalReschedulingLesson({commit, state, dispatch}) {
        commit('setData', {type: 'modalReschedulingLesson', items: true});
    },

    async showModalTeacherReplacement({commit, state, dispatch}) {
        commit('setData', {type: 'modalTeacherReplacement', items: true});
    },

    async showModalStudentAbsences({commit, state, dispatch}) {
        commit('setData', {type: 'modalStudentAbsences', items: true});
    },

    async showModalLessonLink({commit, state, dispatch}, params) {
        commit('setData', {type: 'modalLessonLink', items: true});
    },

    async showModalLessonType({commit, state, dispatch}, params) {
        commit('setData', {type: 'modalLessonType', items: true});
    },

    async getTeachersByPartner({commit, state, dispatch}, item) {
        if (item && item.id) {
            dispatch('loading/addLoading', '', {root: true})
            const {data: items} = await axios.get(url + 'get-teachers-by-partner/' + item.id);
            dispatch('loading/subLoading', '', {root: true})

            commit('setData', {type: 'teachers', items: items});
        } else {
            commit("clearData", {types: ['modules']});
        }
    },

    async rescheduleLesson({commit, state, dispatch}, params){
        dispatch('loading/addLoading', '', {root: true})
        await axios.post(url + 'reschedule-lesson', params);
        dispatch('gradebook/gradebook/getTable', '', {root: true})
        dispatch('loading/subLoading', '', {root: true})
        commit('setData', {type: 'modalReschedulingLesson', items: false});
    },

    async teacherReplace({commit, state, dispatch}, params){
        dispatch('loading/addLoading', '', {root: true})
        await axios.post(url + 'teacher-replacement', params);
        setTimeout(async () => {
            await dispatch('gradebook/gradebook/getTable', '', {root: true})
            dispatch('loading/subLoading', '', {root: true})
        }, 2000)
        commit('setData', {type: 'modalTeacherReplacement', items: false});
    },

    async lessonLink({commit, state, dispatch}, params){
        dispatch('loading/addLoading', '', {root: true})
        await axios.post(url + 'lesson-link', params);
        dispatch('loading/subLoading', '', {root: true})
        commit('setData', {type: 'modalLessonLink', items: false});
    },

    async lessonType({commit, state, dispatch}, params){
        dispatch('loading/addLoading', '', {root: true})
        await axios.post(url + 'lesson-type', params);
        dispatch('gradebook/gradebook/getTable', '', {root: true})
        dispatch('loading/subLoading', '', {root: true})
        commit('setData', {type: 'modalLessonType', items: false});
    },

    hideModal({commit, state, dispatch}, modal) {
        commit('setData', {type: modal, items: false});
    },
};